module.exports = __webpack_public_path__ + "static/media/huoshaoshanadj.82062806.webp";